import OwnAllItemsError from './own-all-items-error.component';

export default OwnAllItemsError;
